<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="TopBar">
      <img src="/grouptest/xmas2019Top.jpg">
    </div>
    <div v-for="item in list" :key="item.num" class="teamRect">
      <div class="line" />
      <div class="num">
        <i v-if="item.num===1" class="iconfont icontopHead" style="color:#F1C78C" />
        <i v-if="item.num===2" class="iconfont icontopHead" style="color:#EEE" />
        <i v-if="item.num===3" class="iconfont icontopHead" style="color:#F1A98C" />
        <div v-if="item.num>3">{{ item.num }}</div>
      </div>
      <div class="master">
        <div class="icon">
          <img :src="item.member[0].icon">
        </div>
        <div class="cap">
          <img src="/grouptest/xmas2019Cap.png">
        </div>
        <div class="name">
          {{ item.member[0].name }}
        </div>
      </div>
      <div class="teamMember">
        <template v-for="(member,index) in item.member">
          <div v-if="index>=1 && index<=3" :key="index" class="icon">
            <img :src="item.member[index].icon">
          </div>
        </template>
        <div v-if="item.totalMember>3" class="total">
          <div>x<span>{{ item.totalMember-1 }}</span></div>
        </div>
      </div>
    </div>

    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import wxShare from '@/components/wxShare'
export default {
  components: {
    [Button.name]: Button,
    TopBar,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '排行榜',
      backurl: '/store/index',
      data: undefined,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      system: undefined,
      list: [1, 2, 3]
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.key = this.$route.params.key
    this.init()
    this.getList()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.shareTitle = this.data.team.shareTitle
        this.shareAbout = this.data.team.shareAbout
        this.shareTimeline = this.data.team.shareTimeline
        this.shareIcon = this.data.team.shareIcon
        this.shareUrl = GetSelfUrl() + 'group/topList/' + this.key + '?system=' + this.system
        this.title = this.data.team.shortName
      })
    },
    getList() {
      request({
        url: '/StoreHelper/getGroupBuyTopList',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    },
    onShareFinish() {
      this.shareUrl = undefined
    }
  }
}
</script>
<style scoped>
.TopBar{
    border-bottom: 2px solid #F1C78C;
}
.TopBar img{
    width: 100%;
    display: block;
}

.teamRect{
    position: relative;
    height: 30vw;
    background-color: #0E4F4E;
}
.teamRect .line{
    position:absolute;
    left: 5vw;
    right: 5vw;
    top:0vw;
    bottom: 0vw;
    border-bottom: 1px dashed #F1C78C;
}
.teamRect .num{
    position: absolute;
    line-height: 30vw;
    left: 2vw;
    color: #F1C78C;
    font-weight: 700;
     text-shadow:5px 2px 6px #000;
     width: 12vw;
     text-align: center;
}
.teamRect .num i{
    font-size: 1.5em;

}
.teamRect .num div{
    position: absolute;
     font-size: 1.1em;
     border:1px solid #F1C78C;
     border-radius: 4vw;
     top:12vw;
     left:3vw;
     width: 6vw;
     height: 6vw;
     line-height: 6vw;
}
.teamRect .master{
    position: absolute;
    width: 12vw;
    height: 12vw;
    left: 15vw;
    top: 9vw;
}
.teamRect .master .icon{
    width: 12vw;
    height: 12vw;
    overflow: hidden;
    border: 2px solid #F1C78C;
    border-radius: 12vw;
}
.teamRect .master .icon img{
    width: 100%;
}
.teamRect .master .cap{
    position: absolute;
    width: 8vw;
    left:2.8vw;
    top:-6vw;
}
.teamRect .master .cap img{
    width: 100%;
}
.teamRect .master .name{
    position: absolute;
    width: 40vw;
    left:-14vw;
    top:14vw;
    text-align: center;
    color: #F1C78C;
    size: 1.1em;
    font-weight: 700;
}
.teamMember{
    display: flex;
    position: absolute;
    left: 35vw;
    right: 0;
    top:9vw;
    bottom: 0;
}
.teamMember .icon{
    width: 12vw;
    height: 12vw;
    overflow: hidden;
    border: 2px solid #F1C78C;
    border-radius: 12vw;
    margin-right: 3vw;
}
.teamMember .icon img{
    width: 100%;
}
.teamMember .total{
    line-height: 12vw;
    color: #F1C78C;
    font-weight: 700;
     text-shadow:5px 2px 6px #000;
     font-style: italic;
}
.teamMember .total div{
    font-size: 1.5em;
}
.teamMember .total div span{
font-size: 1.3em;
}
</style>
